/**
 * *****************************************************
 * ╔╦╗╔═╗  ╔╗╔╔═╗╔╦╗  ╔╦╗╔═╗╔╦╗╦╔═╗╦ ╦  ╔═╗╔╦╗╔═╗╔╦╗╔═╗┬
 *  ║║║ ║  ║║║║ ║ ║   ║║║║ ║ ║║║╠╣ ╚╦╝  ╚═╗ ║ ╠═╣ ║ ║╣ │
 * ═╩╝╚═╝  ╝╚╝╚═╝ ╩   ╩ ╩╚═╝═╩╝╩╚   ╩   ╚═╝ ╩ ╩ ╩ ╩ ╚═╝o
 * ALWAYS RETURN A COPY
 * *****************************************************
 */

import { OFFER_DETAILS } from '../actions/constants';

export default function offerDetails(state = {}, action) {
  switch (action.type) {
    case OFFER_DETAILS.OPEN: {
      const stateCopy = Object.assign({}, state);

      stateCopy.offerId = action.data.offerId;

      return stateCopy;
    }

    case OFFER_DETAILS.CLOSE: {
      const stateCopy = Object.assign({}, state);

      stateCopy.offerId = null;

      return stateCopy;
    }

    default:
      return state;
  }
}
